import { isNaN, isNil } from 'lodash/fp';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { LocalizedTextProps } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const minMaxValidator =
    (
        min: number,
        max: number,
        message: Mews.TextKey | LocalizedTextProps = {
            textKey: TextKey.NumberPickerValidationErrorMessage,
            substitutes: { min, max },
        }
    ) =>
    (fieldValue: string) => {
        const container = getContainer();
        const { appLocalizationComponent } = container();

        if (!isNil(fieldValue)) {
            const parsedNumber = appLocalizationComponent.parseNumber(fieldValue);
            if (!isNaN(parsedNumber) && (parsedNumber < min || parsedNumber > max)) {
                return message;
            }
        }

        return undefined;
    };
